import { useState } from "react"
import { MoreVertical, Pencil, Trash2 } from "lucide-react"
import { useAuth } from "../../contexts/authContext"
import { Link } from "react-router";

function TopicCard({ topic, onEdit, onDelete }) {
    let {user} = useAuth();
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const handleDelete = () => {
        onDelete?.(topic)
        setShowDeleteModal(false)
    }

    return (
      <>
      <div className="card w-full max-w-sm bg-base-100 shadow-xl hover:shadow-2xl transition-shadow duration-200">
        {user && user.is_admin && (
          <div className="absolute right-2 top-2 z-10">
            <div className="dropdown dropdown-end">
              <label tabIndex={0} className="btn btn-ghost btn-circle btn-sm">
                <MoreVertical className="w-4 h-4 rotate-90" />
              </label>
              <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow-lg bg-base-100 rounded-box w-40">
                <li>
                  <button onClick={() => onEdit?.(topic)} className="text-xs font-medium">
                    <Pencil className="w-4 h-4" />
                    Edit Topic
                  </button>
                </li>
                <li>
                  <button onClick={() => setShowDeleteModal(true)} className="text-error text-xs font-medium">
                    <Trash2 className="w-4 h-4" />
                    Delete Topic
                  </button>
                </li>
              </ul>
            </div>
          </div>
        )}
        {topic?.image ? (
          <figure>
            <img src={topic?.image || "/placeholder.svg"} alt={topic?.title} className="w-full h-48 object-cover" />
          </figure>
        ) : (
          <div className="h-48 bg-base-200 flex items-center justify-center">
            <span className="text-base-content/50">No image available</span>
          </div>
        )}
  
        <div className="card-body">
          <h2 className="card-title text-xl font-bold">{topic.title}</h2>
          <p className="text-base-content/70 line-clamp-3">{topic.description}</p>
          <div className="card-actions justify-between items-center mt-4">
            <Link to={`/topics/${topic.course_detail.id}/`} className="badge badge-primary badge-outline h-fit">{topic.course_detail.title}</Link>
            <Link to={`/topics/${topic.id}/quizzes`} className="btn btn-primary btn-sm">View</Link>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <dialog className={`modal modal-bottom sm:modal-middle ${showDeleteModal ? "modal-open" : ""}`}>
        <div className="modal-box">
          <h3 className="font-bold text-lg">Confirm Delete</h3>
          <p className="py-4">Are you sure you want to delete &quot;{topic.title}&quot;? This action cannot be undone.</p>
          <div className="modal-action">
            <button className="btn" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </button>
            <button className="btn btn-error text-white" onClick={handleDelete}>
              Delete
            </button>
          </div>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button onClick={() => setShowDeleteModal(false)}>close</button>
        </form>
      </dialog>
      </>
    )
  }

export default TopicCard;
  
  